import { render, staticRenderFns } from "./community-portal.vue?vue&type=template&id=60164898&"
import script from "./community-portal.vue?vue&type=script&lang=js&"
export * from "./community-portal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports